import { Epg, Layout } from "@nessprim/planby";

// Import hooks
import { useApp } from "./useApp";

// ----- Please uncomment the following lines to see the custom components -----
// Import components
import {
  CustomTimeline,
  ChannelItem,
  Line,
  LiveTime,
  Program,
} from "./components";

function App() {
  const { isLoading, getEpgProps, getLayoutProps, onChangeTimezone } = useApp();

  return (
    <div>
      <div style={{ margin: 10 }}>
        <p>Timezone:</p>
        <select onChange={(e) => onChangeTimezone(e)}>
          <option value="Europe/Paris">Europe/Paris</option>
          <option value="Europe/London">Europe/London</option>
          <option value="Asia/Dubai">Asia/Dubai</option>
          <option value="America/New_York">America/New_York</option>
        </select>
      </div>
      <div style={{ height: "770px", width: "99%" }}>
        <Epg isLoading={isLoading} {...getEpgProps()}>
          <Layout
            {...getLayoutProps()}
            // ----- Please uncomment the following lines to see the custom components -----
            // renderLine={(props) => <Line {...props} />}
            // renderCurrentTime={(props) => <LiveTime {...props} />}
            // renderTimeline={(props) => <CustomTimeline {...props} />}
            // renderProgram={({ program, ...rest }) => (
            //   <Program
            //     key={`${program.data.channelUuid}-${program.data.id}`}
            //     program={program}
            //     {...rest}
            //   />
            // )}
            renderChannel={({ channel, ...rest }) => (
              <ChannelItem key={channel.uuid} channel={channel} {...rest} />
            )}
          />
        </Epg>
      </div>
    </div>
  );
}

export default App;
